// extracted by mini-css-extract-plugin
export default {"fillContainer":"fill-container__hhGmBR_0","fullScreen":"full-screen__fuNVY4wH"};